import { render, staticRenderFns } from "./EditPersonForm.vue?vue&type=template&id=3d4d8f12"
import script from "./EditPersonForm.vue?vue&type=script&lang=ts"
export * from "./EditPersonForm.vue?vue&type=script&lang=ts"
import style0 from "./EditPersonForm.vue?vue&type=style&index=0&id=3d4d8f12&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports